import { render } from "./FrecuentAccessComponent.vue?vue&type=template&id=01c92be8"
import script from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"
export * from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__